
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#95989a","d":"M113.667 31v12.917a2.584 2.584 0 01-2.584 2.583h-5.166a2.584 2.584 0 01-2.584-2.583V31H90.417a2.584 2.584 0 01-2.584-2.583V23.25a2.583 2.583 0 012.584-2.583h12.916c5.707 0 10.334 4.626 10.334 10.333zm-77.5-7.75a2.583 2.583 0 00-2.584-2.583H20.667c-5.707 0-10.334 4.626-10.334 10.333v12.917a2.584 2.584 0 002.584 2.583h5.166a2.584 2.584 0 002.584-2.583V31h12.916a2.584 2.584 0 002.584-2.583V23.25zm74.916 54.25h-5.166a2.584 2.584 0 00-2.584 2.583V93H90.417a2.584 2.584 0 00-2.584 2.583v5.167a2.583 2.583 0 002.584 2.583h12.916c5.707 0 10.334-4.626 10.334-10.333V80.083a2.584 2.584 0 00-2.584-2.583zM36.167 95.583A2.584 2.584 0 0033.583 93H20.667V80.083a2.584 2.584 0 00-2.584-2.583h-5.166a2.584 2.584 0 00-2.584 2.583V93c0 5.707 4.627 10.333 10.334 10.333h12.916a2.583 2.583 0 002.584-2.583v-5.167z"}})])
          )
        }
      }
    